import $ from 'jquery';

$('.filter-toggle').on('click', () => {
    $('.filter').toggleClass('filter--active');
});

$('.filter .menu-item-has-children > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('.sub-menu');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('300');
});

$('.filter__menu--products a').each(function () {
    const $this = $(this);
    const parent = $this.parent();
    const children = parent.find('.children');

    if (children.length) {
        children.before(
            '<button type="button" class="children-button"><i class="onsc-icons-arrow-right"></i></button>'
        );
    }

    if (parent.hasClass('current-cat-ancestor')) {
        parent.addClass('submenu-active');
        parent.find('.children').show();
        parent.find('i').toggleClass('onsc-icons-arrow-right onsc-icons-close');
    }
});

$(document).on(
    'click',
    '.filter__menu--products .children-button',
    function () {
        const $this = $(this);
        const currentList = $this.parent();
        const currentMenu = currentList.find('ul');

        $this.find('i').toggleClass('onsc-icons-arrow-right onsc-icons-close');
        currentList.toggleClass('submenu-active');
        currentMenu.slideToggle('200');
    }
);

$('.filter__has-submenu > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('ul');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('200');
});

const setOpenerPos = () => {
    const bodyWidth = $('body').outerWidth();
    const containerWidth = $('.container').outerWidth();
    const opener = $('.filter-opener');
    const pos = (bodyWidth - containerWidth) / 2 - 80;

    if (window.matchMedia('(min-width: 575px)').matches && pos >= 100) {
        opener.css({
            left: `calc(${(bodyWidth - containerWidth) / 2 - 80}px)`,
        });
    } else {
        opener.css({
            left: '20px',
        });
    }
};

$('.filter--recipes .filter__menu a').on('click', () => {
    if (window.matchMedia('(max-width: 575px)').matches) {
        $('.filter--recipes').removeClass('filter--active');
    }
});

$(window).on('resize', setOpenerPos).trigger('resize');
